import { Injectable } from '@angular/core'
import { SetupIntent } from '@stripe/stripe-js'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { AttachPaymentMethodResponse } from './stripe.models'

@Injectable({
  providedIn: 'root',
})
export class StripeApiService extends GbApiService {
  setupIntent(profileId: string | number, urlName: string): Observable<SetupIntent> {
    const url = `auctions/${urlName}/setup-intents/`
    const payload = {
      profile: profileId,
      return_url: `${this.appConfig.frontendUrl}account/billing/payment-methods/`, //TODO: maybe this should be different?
    }
    return this.post<SetupIntent>(url, payload)
  }

  attachPaymentMethod(
    paymentMethodId: string,
    stripeConnect: string | undefined,
    user: string | undefined,
    urlName: string,
    stripeCustomer: string | undefined,
  ): Observable<AttachPaymentMethodResponse> {
    const url = `auctions/${urlName}/customers/${stripeCustomer}/attach_payment_method/`
    const payload = {
      payment_method_id: paymentMethodId,
      stripe_connect: stripeConnect,
      user: user,
    }

    return this.post<AttachPaymentMethodResponse>(url, payload)
  }

  /**
   * Cancel payment api service
   * @param urlName auction url name
   * @param uuid payment uuid
   * @param payload
   * @returns Observable<>
   */
  cancelPayment(urlName: string, uuid: string | undefined) {
    const url = `auctions/${urlName}/payments/${uuid}/cancel/`
    return this.post(url)
  }
}
